import { getCTAPhoneTemplate } from "../../shortcodes/templates";
import { getShortcodeWrapper, addShortcodeToEditor } from "../../shortodeAddition";

const ctaPhoneConfig = (tinymce, uuid, shortcodeOnClick) => {
  tinymce.activeEditor.windowManager.open({
    title: "Call CTA #1",
    body: {
      type: "panel",
      items: [
        {
          type: "input",
          name: "text",
          label: "Button text",
          placeholder: "Button text",
        },
        {
          type: "input",
          name: "number",
          label: "Phone number",
          placeholder: "tel:+0000000000",
        },
        {
          type: "colorinput",
          name: "bgColor",
          label: "Button color",
        },
      ],
    },
    initialData: {
      bgColor: "#28b02b",
    },
    buttons: [
      {
        type: "cancel",
        name: "close",
        text: "Cancel",
      },
      {
        type: "submit",
        name: "submit",
        text: "Add",
        primary: true,
      },
    ],
    onSubmit: api => {
      const data = api.getData();
      const parentElement = tinymce.activeEditor.selection.getNode().nodeName.toLowerCase();

      const templateToAdd = getCTAPhoneTemplate({
        text: data.text,
        number: data.number,
        bgColor: data.bgColor,
      });

      const shortcodeWrapper = getShortcodeWrapper(uuid, shortcodeOnClick, templateToAdd);
      addShortcodeToEditor(shortcodeWrapper, uuid, parentElement, api);
      api.close();
    },
  });
};

export { ctaPhoneConfig };
